import {UIGameCanvasController} from '../../../shared/scripts/ui_game/UIGameCanvasController.ts'
import {UIGameResponsiveController} from '../../../shared/scripts/ui_game/UIGameResponsiveController.ts'
import {type UIWGameManager} from './UIWGameManager.ts'

export class UIWGameCanvasController extends UIGameCanvasController {
    readonly responsiveController: UIGameResponsiveController
    get chatWidth(): number {
        return this.itemSize * 4
    }
    get feedsHeight(): number {
        return this.appH - this.itemSize * 5.5
    }
    get popupWidth(): number {
        return this.itemSize * 5
    }
    get bottomViewHeight(): number {
        return this.itemSize
    }

    constructor(uiGameManager: UIWGameManager) {
        super(uiGameManager)
        this.responsiveController = new UIGameResponsiveController(uiGameManager)
    }

    setupGameContainers() {
        super.setCanvasConfigVariables()

        this.kickOffAppLoading()
        this.addTicker()
    }
}
